import { render, staticRenderFns } from "./EmployeeLoanInfo.vue?vue&type=template&id=ffcb5958"
import script from "./EmployeeLoanInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeLoanInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports